import { mapValues } from 'lodash'

export const nullifyEmptyStringFields = (data: any): any =>
  mapValues(data, (val) => (val === '' ? null : val))
